import { inject } from 'tsyringe'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { containerScoped } from '~/decorators/dependency-container'
import { toCamelCase } from '~/utils/object'

@containerScoped()
export default class ClassifiedSearchService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  getFacets(params: any) {
    return this.requestBuilder
      .request('get', '/api/classifieds/search/facets/')
      .params(params)
      .map((response: any) => {
        return {
          ...toCamelCase(response.data),
          targetSeoUrl: response._page.target_seo_url,
          metadata: response._page.metadata
        }
      })
      .previousRequestCancelable()
      .send()
  }

  getRentalsPopularSearches() {
    return this.requestBuilder
      .request('get', '/api/rentals/popular-searches/')
      .send()
  }
}
